// Function to create a cookie available for all subdomains
function createCookie(name, value, days=30) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${name}=${encodeURIComponent(value)}${expires}; path=/; domain=${getBaseDomain()}`;
}

// Function to get a cookie by name
function getCookie(name) {
    const nameEQ = `${name}=`;
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim();
        if (cookie.indexOf(nameEQ) === 0) {
            return decodeURIComponent(cookie.substring(nameEQ.length));
        }
    }
    return null;
}

// Function to delete a cookie for all subdomains
function deleteCookie(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${getBaseDomain()}`;
}

// Utility function to get the base domain (e.g., example.com)
function getBaseDomain() {
    const hostParts = window.location.hostname.split('.');
    if (hostParts.length > 2) {
        return `.${hostParts.slice(-2).join('.')}`;
    }
    return window.location.hostname; // For localhost or single-word domains
}

export { createCookie, getCookie, deleteCookie };